import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>Tyvärr, sidan kan inte hittas!</h3>
  </div>;
